var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddZone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8682_94369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3.33333C20 1.49567 18.5043 0 16.6667 0C15.2587 0.004 14.006 0.894 13.539 2.22233H6.461C5.994 0.894 4.74133 0.004 3.33333 0C1.49567 0 0 1.49567 0 3.33333C0 4.78 0.932333 6.001 2.22233 6.461V13.5377C0.894667 14.006 0.005 15.2587 0 16.6667C0 18.5043 1.49567 20 3.33333 20C4.74133 19.996 5.994 19.106 6.461 17.7777H13.5377C14.005 19.1057 15.2577 19.9957 16.6653 20C18.503 20 19.9987 18.5043 19.9987 16.6667C19.9937 15.2587 19.104 14.006 17.7763 13.5377V6.46233C19.105 5.99467 19.9953 4.74167 20 3.33333ZM16.6667 2.22233C17.281 2.22167 17.7793 2.71933 17.78 3.33333C17.7807 3.94767 17.283 4.446 16.669 4.44667C16.0547 4.44733 15.5563 3.94967 15.5557 3.33567C15.5557 3.335 15.5557 3.33433 15.5557 3.33333C15.5557 2.721 16.0533 2.22233 16.6667 2.22233ZM13.539 15.5557H6.461C6.12633 14.614 5.38567 13.873 4.44433 13.538V6.46233C5.38567 6.12733 6.12633 5.38633 6.461 4.44467H13.5377C13.8727 5.386 14.6137 6.12667 15.5553 6.46133V13.538C14.614 13.8727 13.8733 14.614 13.539 15.5557ZM3.33333 2.22233C3.94767 2.22167 4.446 2.71933 4.44667 3.33333C4.44733 3.94733 3.94967 4.446 3.33567 4.44667C2.72167 4.44733 2.223 3.94967 2.22233 3.33567C2.22233 3.335 2.22233 3.33433 2.22233 3.33333C2.22233 2.721 2.72 2.22233 3.33333 2.22233ZM3.33333 17.7777C2.71967 17.7503 2.24433 17.2307 2.272 16.617C2.29767 16.0417 2.75833 15.5813 3.33333 15.5557C3.947 15.583 4.42233 16.1027 4.39467 16.7163C4.369 17.2917 3.90867 17.752 3.33333 17.7777ZM16.6667 17.7777C16.053 17.7503 15.5777 17.2307 15.6053 16.617C15.631 16.0417 16.0917 15.5813 16.6667 15.5557C17.2803 15.583 17.7557 16.1027 17.728 16.7163C17.7023 17.2917 17.242 17.752 16.6667 17.7777Z",
    fill: "#60616E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 2,
    height: 6,
    fill: "#60616E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 6,
    height: 2,
    fill: "#60616E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8682_94369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddZone);
export default __webpack_public_path__ + "static/media/add-zone.ecb2cfd3ae5103ef7baab06d7820f5af.svg";
export { ForwardRef as ReactComponent };